var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9347 11.2077C12.8851 11.2077 11.9455 11.6865 11.322 12.437L7.26645 10.1344C7.39257 9.77952 7.46189 9.39792 7.46189 9.00024C7.46189 8.60263 7.39257 8.22103 7.26645 7.86613L11.3217 5.56297C11.9451 6.31374 12.8849 6.7927 13.9345 6.7927C15.8068 6.7927 17.3301 5.26891 17.3301 3.39584C17.3302 1.52332 15.807 0 13.9347 0C12.0622 0 10.5388 1.52332 10.5388 3.39576C10.5388 3.79344 10.608 4.17512 10.7342 4.5301L6.67872 6.83334C6.05534 6.08297 5.1158 5.60432 4.06645 5.60432C2.1937 5.60432 0.670062 7.12764 0.670062 9.00016C0.670062 10.8726 2.1937 12.3959 4.06645 12.3959C5.1158 12.3959 6.05526 11.9173 6.67864 11.167L10.7342 13.4697C10.608 13.8246 10.5387 14.2064 10.5387 14.6042C10.5387 16.4766 12.0621 17.9999 13.9346 17.9999C15.8069 17.9999 17.3301 16.4765 17.3301 14.6042C17.3302 12.7314 15.807 11.2077 13.9347 11.2077ZM13.9347 1.1883C15.1518 1.1883 16.1419 2.17854 16.1419 3.39576C16.1419 4.6136 15.1518 5.60432 13.9347 5.60432C12.7174 5.60432 11.7271 4.6136 11.7271 3.39576C11.7271 2.17854 12.7174 1.1883 13.9347 1.1883ZM4.06653 11.2077C2.849 11.2077 1.85844 10.2174 1.85844 9.00024C1.85844 7.78295 2.849 6.7927 4.06653 6.7927C5.28358 6.7927 6.27367 7.78295 6.27367 9.00024C6.27367 10.2174 5.2835 11.2077 4.06653 11.2077ZM13.9347 16.8117C12.7174 16.8117 11.7271 15.8214 11.7271 14.6042C11.7271 13.3866 12.7174 12.396 13.9347 12.396C15.1518 12.396 16.1419 13.3866 16.1419 14.6042C16.1419 15.8214 15.1518 16.8117 13.9347 16.8117Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.a8ba458f0a2f49003720eeddd1352cf3.svg";
export { ForwardRef as ReactComponent };